<template>
  <div class="adm-login">
    <div class="adm-login__page-bg" aria-hidden="true" />
    <div class="adm-login__card">
      <div class="adm-login__head" :style="headBgStyle">
        <div class="adm-login__head-inner">
          <h1 class="adm-login__title">管理员登录</h1>
          <p class="adm-login__sub">平台管理入口，请使用管理员账号与密码登录</p>
        </div>
      </div>

      <div class="adm-login__body">
        <el-form
          ref="form"
          class="adm-login__form"
          :model="form"
          :rules="rules"
          label-position="top"
          @submit.native.prevent
        >
          <el-form-item label="管理员账号" prop="username">
            <el-input
              v-model="form.username"
              placeholder="输入管理员账号"
              clearable
              autocomplete="username"
            >
              <template slot="prefix">
                <img class="adm-login__input-ico" :src="slice('account.png')" alt="" role="presentation" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              placeholder="输入您的密码"
              show-password
              autocomplete="current-password"
              @keyup.enter.native="submit"
            >
              <template slot="prefix">
                <img class="adm-login__input-ico" :src="slice('password.png')" alt="" role="presentation" />
              </template>
            </el-input>
          </el-form-item>
          <div class="adm-login__row-extra">
            <el-checkbox v-model="form.remember" class="adm-login__remember">记住我</el-checkbox>
          </div>
          <el-button
            type="primary"
            class="adm-login__submit"
            :loading="loading"
            native-type="button"
            @click="submit"
          >
            <span>登录管理端</span>
            <img
              v-if="!loading"
              class="adm-login__go-ico"
              :src="slice('go.png')"
              alt=""
              role="presentation"
            />
          </el-button>
        </el-form>

        <div class="adm-login__secure">
          <img class="adm-login__secure-ico" :src="slice('safety.png')" alt="" role="presentation" />
          <span class="adm-login__secure-txt">BANK-LEVEL SECURITY ENCRYPTION</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { adminApi } from '@/api/admin'

export default {
  name: 'AdminLogin',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: '',
        remember: true
      },
      rules: {
        username: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  computed: {
    headBgStyle() {
      return {
        backgroundImage: `url(${this.slice('login_form_top_bg.png')})`
      }
    }
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    },
    slice(name) {
      return this.base() + 'slices/login/' + encodeURIComponent(name)
    },
    submit() {
      this.$refs.form.validate(async (ok) => {
        if (!ok) return
        this.loading = true
        try {
          const res = await adminApi.login({
            username: this.form.username,
            password: this.form.password
          })
          const d = res.data || {}
          sessionStorage.setItem('cryptopay_admin_token', d.token || '')
          sessionStorage.setItem('admin_nickname', d.nickname || '')
          const redirect = this.$route.query.redirect || '/dashboard'
          this.$router.replace(redirect)
        } catch (e) {
          /* 拦截器已提示 */
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$line: #e2e8f0;
$muted: #64748b;
$blue: #2563eb;

.adm-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 32px 20px;
  overflow-x: hidden;
}

.adm-login__page-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(180deg, #dcebff 0%, #e8f2ff 28%, #f5f9ff 55%, #ffffff 100%);
  pointer-events: none;
}

.adm-login__card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 515px;
  border-radius: 24px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 24px 64px rgba(15, 64, 130, 0.12), 0 8px 24px rgba(15, 23, 42, 0.08);
}

.adm-login__head {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 51px 28px 50px;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  position: relative;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
}

.adm-login__head-inner {
  position: relative;
  z-index: 1;
  text-align: center;
}

.adm-login__title {
  margin: 0 0 10px;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
  text-shadow: 0 1px 12px rgba(0, 0, 0, 0.2);
}

.adm-login__sub {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
}

.adm-login__body {
  padding: 32px 32px 28px;
  background: #fff;
}

.adm-login__form {
  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
  ::v-deep .el-form-item__label {
    float: none;
    line-height: 1.2;
    padding: 0 0 6px;
    color: $muted;
    font-size: 13px;
    font-weight: 400;
  }
  ::v-deep .el-form-item__content {
    line-height: normal;
  }
  ::v-deep .el-input__inner {
    height: 48px;
    line-height: 48px;
    padding-left: 44px;
    border-radius: 12px;
    border: 1px solid $line;
    background: #fff;
    color: #0f172a;
    font-size: 15px;
    &::placeholder {
      color: #94a3b8;
    }
    &:hover {
      border-color: #cbd5e1;
    }
    &:focus {
      border-color: $blue;
    }
  }
  ::v-deep .el-input__prefix {
    left: 12px;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    background: #f8fafc;
  }
}

.adm-login__input-ico {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
  opacity: 0.8;
}

.adm-login__row-extra {
  margin: 4px 0 20px;
}

.adm-login__remember {
  ::v-deep .el-checkbox__label {
    color: $muted;
    font-size: 13px;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $blue;
    border-color: $blue;
  }
  ::v-deep .el-checkbox__inner {
    border-radius: 4px;
  }
}

.adm-login__submit {
  width: 100%;
  min-height: 56px;
  height: 56px;
  line-height: 1.2;
  border: none !important;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 !important;
  background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%) !important;
  box-shadow: 0 8px 24px rgba(8, 80, 240, 0.28);
  &:hover,
  &:focus {
    background: linear-gradient(221deg, #0640c8 0%, #0f4fd4 7.39%, #00a0e0 100%) !important;
    color: #fff !important;
  }
}

.adm-login__go-ico {
  margin-left: 12px;
  width: 12px;
  height: 12px;
  object-fit: contain;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
  opacity: 0.95;
}

.adm-login__secure {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
  padding-top: 4px;
}

.adm-login__secure-ico {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
}

.adm-login__secure-txt {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.14em;
  color: #94a3b8;
  line-height: 1.2;
}
</style>
